import React from 'react'
import css from './WelcomeKontakt.module.css'

const WelcomeKontakt = () => {
	return (
		<section className={css.welcomeSection}>
			<div className={css.welcomeContainer}>
				<p className={css.welcomeText}>KONTAKT</p>
			</div>
		</section>
	)
}

export default WelcomeKontakt
